import CarrierBaseController from '../common/carrier.base.controller'

class CarrierCreateController extends CarrierBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, CarrierService, Modal, $translate, UserBranchService, CarrierBranchService) {

		super(Auth, $state, User, CarrierService, Modal, $translate, UserBranchService, CarrierBranchService)

		this.UserBranchService = UserBranchService;
		this.CarrierBranchService = CarrierBranchService;

		this.defaultModel = {
			id: '',
			name: '',
			description: '',
			POCName: '',
			POCEmail: '',
			POCPhone: '',
			allBranch: [],
			branch: '',
			loggedInUser: User.getUser().id
		}
		this.model = angular.copy(this.defaultModel);
		this.branches = []
	}
	$onInit() {
		this.loading = false;
		this.loadBranch()
	}

	reset() {
		this.model = angular.copy(this.defaultModel);
		this.clearErrors();
		this.resetMultiBranchSelection();
	}

	submit(evt) {
		this.loading = true
		this.Service.create({
			id: this.model.id,
			name: this.model.name,
			description: this.model.description,
			POCPhone: this.model.POCPhone,
			POCEmail: this.model.POCEmail,
			POCName: this.model.POCName,
			branchId: this.model.defaultBranch
		})
			.then((data) => {
				this.loading = false;
				this.createCarrierBranch();
				this.askCreate()
			})
			.catch((err) => {
				this.loading = false
				err.data.errors.map((e) => {
					this.errorMessage += e.message + '<br/>'
				})
			})
	}

	// Reset Multi-Branch selection
	resetMultiBranchSelection() {
		if (this.model.branch && this.model.branch.length) {
			this.model.branch.forEach((selectedBranch) => {
				this.model.allBranch.filter((branch) => {
					if (branch.branchId == selectedBranch.branchId) {
						branch.ticked = false;
					}
				})
			})
		}
		this.loadBranch();
	}

	// Load branch user has permission
	loadBranch() {
		this.UserBranchService.getUserBranches(this.model.loggedInUser)
			.then((data) => {
				this.model.allBranch = data.results;
				this.model.allBranch.filter((branch) => {
					if (branch.branchId == this.User.getUser().branchId) {
						branch.ticked = true;
						this.model.defaultBranch = branch.branchId;
					}
				})
			}).catch((err) => {
				console.log(err);
			});
	}

	createCarrierBranch() {
		this.branches = this.model.branch.map((b) => b.branchId)
		this.CarrierBranchService.createBranchGroup(this.model.id, this.branches)
			.then((res) => {
				// console.log(res);
			})
			.catch((err) => {
				console.log(err);
			})
	}
}

export default CarrierCreateController;


// WEBPACK FOOTER //
// ./client/app/components/carrier/create/carrier.create.controller.js